import { SVGProps } from 'react';

const SvgMoon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 16" {...props}>
        <path d="M0 8a7.74 7.74 0 0 0 .9 3.615 8.095 8.095 0 0 0 2.503 2.835 8.52 8.52 0 0 0 3.568 1.442 8.666 8.666 0 0 0 3.862-.26 8.33 8.33 0 0 1-4.22-2.899A7.787 7.787 0 0 1 4.999 8c0-1.703.566-3.36 1.616-4.733a8.331 8.331 0 0 1 4.22-2.899A8.667 8.667 0 0 0 6.97.108 8.52 8.52 0 0 0 3.403 1.55 8.094 8.094 0 0 0 .9 4.385 7.74 7.74 0 0 0 0 8Z" />
    </svg>
);
export default SvgMoon;
